import api from './api';

// Settings API Types
export interface TomTomSettingsResponse {
  apiKeyMasked: string;
  hasApiKey: boolean;
}

export interface TomTomSettingsUpdateRequest {
  apiKey?: string;
}

export interface TomTomTestResponse {
  success: boolean;
  message: string;
}

export interface AviationStackSettingsResponse {
  apiKeyMasked: string;
  hasApiKey: boolean;
}

export interface AviationStackSettingsUpdateRequest {
  apiKey?: string;
}

// Settings API Service
export const settingsApi = {
  /**
   * Get TomTom settings (API key is masked)
   */
  getTomTomSettings: async (): Promise<TomTomSettingsResponse> => {
    const response = await api.get<TomTomSettingsResponse>('/api/settings/tomtom');
    return response.data;
  },

  /**
   * Update TomTom settings
   */
  updateTomTomSettings: async (settings: TomTomSettingsUpdateRequest): Promise<TomTomSettingsResponse> => {
    const response = await api.put<TomTomSettingsResponse>('/api/settings/tomtom', settings);
    return response.data;
  },

  /**
   * Test TomTom connection
   */
  testTomTomConnection: async (): Promise<TomTomTestResponse> => {
    const response = await api.post<TomTomTestResponse>('/api/settings/tomtom/test');
    return response.data;
  },

  /**
   * Get AviationStack settings
   */
  getAviationStackSettings: async (): Promise<AviationStackSettingsResponse> => {
    const response = await api.get<AviationStackSettingsResponse>('/api/settings/aviationstack');
    return response.data;
  },

  /**
   * Update AviationStack settings
   */
  updateAviationStackSettings: async (settings: AviationStackSettingsUpdateRequest): Promise<AviationStackSettingsResponse> => {
    const response = await api.put<AviationStackSettingsResponse>('/api/settings/aviationstack', settings);
    return response.data;
  },
};

export default settingsApi;

